<template>
  <div class="row align-center my-5 radius-20">
    <div class="elevation-1  col-12 radius-20">
      <div class="radius-20">
        <div class="card-section">
          <span class="text-barlow-condensed subtitle text-dark">
            Respuestas en total
          </span>
        </div>
        <div class="card-section">
          <Legend />
        </div>
        <div
          v-for="(data, i) in stackData"
          :key="i"
          class="card-section text-center"
        >
          <HorizontalStackedBar :data="data" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HorizontalStackedBar from "@/components/HorizontalStackedBar";
import Legend from "@/components/detailBySkill/Legend";

export default {
  name: "root",
  components: {
    HorizontalStackedBar,
    Legend,
  },
  props: ["data"],
  data() {
    return {
      stackData: null,
    };
  },
  async mounted() {
    try {
      this.data;

      this.stackData = [
        {
          label: this.$t("habilities.LOC"),
          correct: this.data.porcentajeCorrectasLocalizar,
          incorrect: this.data.porcentajeIncorrectasLocalizar,
          notAnswered: this.data.porcentajeNoContestadasLocalizar,
        },
        {
          label: this.$t("habilities.RV"),
          correct: this.data.porcentajeCorrectasReflexionar,
          incorrect: this.data.porcentajeIncorrectasReflexionar,
          notAnswered: this.data.porcentajeNoContestadasReflexionar,
        },
        {
          label: this.$t("habilities.IN"),
          correct: this.data.porcentajeCorrectasIntegrar,
          incorrect: this.data.porcentajeIncorrectasIntegrar,
          notAnswered: this.data.porcentajeNoContestadasIntegrar,
        },
      ];
    } catch {
      // Do something with error
    }
  },
};
</script>
